<template>
  <div id="app">
    <div class="content">
      <p class="content__title">
        vue-awesome-buttons
      </p>
      <github-button
        class="content__button"
        href="https://github.com/mrcointreau/vue-awesome-buttons"
        data-size="large"
        data-show-count="true"
        >Star</github-button
      >
      <div class="content__row content__row--block">
        <p class="content__row__title">display: block;</p>
        <button-upgrade class="button button-upgrade" />
        <button-learn-more class="button button-learn-more" />
        <button-get-started class="button button-get-started" />
        <button-subscribe class="button button-subscribe" />
        <button-create class="button button-create" />
      </div>
      <div class="content__row content__row--block content__row--min-width">
        <p class="content__row__title">display: block; min-width: 10rem;</p>
        <button-upgrade label="KEEP" class="button button-upgrade" />
        <button-learn-more label="CALM" class="button button-learn-more" />
        <button-get-started label="AND" class="button button-get-started" />
        <button-subscribe label="HOVER" class="button button-subscribe" />
        <button-create label="BUTTONS" class="button button-create" />
      </div>
      <div class="content__row content__row--inline">
        <p class="content__row__title">display: inline;</p>
        <br />
        <button-upgrade label="HOUSTON" class="button button-upgrade" />
        <button-learn-more label="WE" class="button button-learn-more" />
        <button-get-started label="HAVE" class="button button-get-started" />
        <button-subscribe label="A" class="button button-subscribe" />
        <button-create label="PROBLEM" class="button button-create" />
      </div>
      <div class="content__row content__row--inline content__row--min-width">
        <p class="content__row__title">display: inline; min-width: 10rem;</p>
        <br />
        <button-upgrade label="KEEP" class="button button-upgrade" />
        <button-learn-more label="CALM" class="button button-learn-more" />
        <button-get-started label="AND" class="button button-get-started" />
        <button-subscribe label="HOVER" class="button button-subscribe" />
        <button-create label="BUTTONS" class="button button-create" />
      </div>
      <div class="content__row content__row--inline content__row--font-size">
        <p class="content__row__title">custom font-size</p>
        <br />
        <button-upgrade label="HOUSTON" class="button button-upgrade" />
        <button-learn-more label="WE" class="button button-learn-more" />
        <button-get-started label="HAVE" class="button button-get-started" />
        <button-subscribe label="A" class="button button-subscribe" />
        <button-create label="PROBLEM" class="button button-create" />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonCreate from 'vue-awesome-buttons/src/components/ButtonCreate'
import ButtonSubscribe from 'vue-awesome-buttons/src/components/ButtonSubscribe'
import ButtonUpgrade from 'vue-awesome-buttons/src/components/ButtonUpgrade'
import ButtonGetStarted from 'vue-awesome-buttons/src/components/ButtonGetStarted'
import ButtonLearnMore from 'vue-awesome-buttons/src/components/ButtonLearnMore'
import GithubButton from 'vue-github-button'

export default {
  name: 'app',

  components: {
    ButtonCreate,
    ButtonSubscribe,
    ButtonUpgrade,
    ButtonGetStarted,
    ButtonLearnMore,
    GithubButton
  }
}
</script>

<style>
@font-face {
  font-family: Mulish;
  src: url(~@/assets/fonts/Mulish-Regular.ttf) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
}

@font-face {
  font-family: Mulish;
  src: url(~@/assets/fonts/Mulish-Bold.ttf) format('truetype');
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
}

html,
body {
  margin: 0;
  padding: 0;
  font-size: 20px;
}

* {
  box-sizing: border-box;
}

#app {
  overflow: auto;
  font-family: Mulish, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.content {
  text-align: center;
}

.content__title {
  position: relative;
  margin: 0;
  padding: 0.5rem;
  background-color: #3a3335;
  font-size: 2rem;
  font-weight: bold;
  color: #fff;
}

.content__button {
  display: inline-block;
  margin: 0 auto;
  padding: 0 0 0.75rem 0;
  width: 100%;
  background-color: #3a3335;
}

.content__row {
  overflow: auto;
  padding: 1rem;
}

.content__row__title {
  display: inline-block;
  margin: 1rem 0;
  padding: 0.5rem;
  background-color: #3a3335;
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
}

.content__row .button {
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  white-space: nowrap;
}

.content__row--min-width .button {
  min-width: 10rem;
}

.content__row--block {
  background-color: #70d6ff;
}

.content__row--block .button {
  display: block;
  margin: 1rem auto;
}

.content__row--block.content__row--min-width {
  background-color: #ff70a6;
}

.content__row--block .content__row__buttons {
  align-items: center;
}

.content__row--inline {
  background-color: #ff9770;
}

.content__row--inline .button {
  margin: 1rem 0.5rem;
}

.content__row--inline.content__row--min-width {
  background-color: #e9ff70;
}

.content__row--inline.content__row--font-size {
  background-color: #00a878;
}

.content__row--inline.content__row--font-size .button-upgrade {
  font-size: 1rem;
}

.content__row--inline.content__row--font-size .button-learn-more {
  font-size: 1.2rem;
}

.content__row--inline.content__row--font-size .button-get-started {
  font-size: 1.4rem;
}

.content__row--inline.content__row--font-size .button-subscribe {
  font-size: 1.6rem;
}

.content__row--inline.content__row--font-size .button-create {
  font-size: 1.8rem;
}

.button-upgrade {
  background-color: #ffc04c;
  color: #3a3335;
}

.button-learn-more {
  background-color: #f2fafe;
  color: #3a3335;
}

.button-get-started {
  background-color: #2146ec;
  color: #fff;
}

.button-subscribe {
  background-color: #da6056;
  color: #fff;
}

.button-create {
  background-color: #9f51f3;
  color: #fff;
}
</style>
